import type { ChatSettingsTranslation } from './types';

export const chatSettingsUr: ChatSettingsTranslation = {
  open: 'چیٹ کی ترتیبات',
  openLabel: '{{name}} کی چیٹ کی ترتیبات',
  title: '{{name}} کی چیٹ کی ترتیبات',
  description:
    'چیٹ آپ کی ویب سائٹ پر کیسے دکھے اور گاہک اس میں کیا کر سکیں۔ تبدیلیاں ایک منٹ میں ویب سائٹس تک پہنچتی ہیں۔',
  saved: '{{name}} کی چیٹ کی ترتیبات محفوظ ہو گئیں۔',
  save: 'ترتیبات محفوظ کریں',
  loading: 'چیٹ کی ترتیبات لوڈ ہو رہی ہیں',
  invalidNumber: '{{min}} سے {{max}} تک کوئی مکمل عدد لکھیں۔',
  languages: { en: 'انگریزی', ar: 'عربی', hi: 'ہندی', ur: 'اردو' },
  layout: {
    legend: 'چیٹ کہاں دکھے',
    bubble: 'تیرتا بٹن',
    bubbleHint: 'کونے میں ایک گول بٹن چیٹ کھولتا ہے۔',
    panel: 'سائیڈ پینل',
    panelHint: 'بٹن صفحے کے ایک کنارے پر چیٹ کھولتا ہے۔',
    inline: 'صفحے کے اندر',
    inlineHint: 'چیٹ آپ کے صفحے کے اس حصے میں رہتی ہے جو آپ چنیں۔',
    fullpage: 'پورا صفحہ',
    fullpageHint: 'چیٹ پورا صفحہ بھرتی ہے، اپنے الگ مدد کے صفحے کے لیے۔',
    side: 'بٹن کا کونا',
    right: 'نیچے دائیں',
    left: 'نیچے بائیں',
    note: 'فون پر تیرتا بٹن اور سائیڈ پینل چیٹ کو پوری اسکرین پر کھولتے ہیں۔',
  },
  files: {
    legend: 'فائلیں',
    enabled: 'گاہک فائلیں بھیج سکتے ہیں',
    enabledHint:
      'ہر فائل کی پہلے وائرس جانچ ہوتی ہے۔ سرور پر وائرس اسکینر نہ ہو تو چیٹ میں فائلیں نہیں بھیجی جا سکتیں۔',
    types: 'فائلوں کی اقسام',
    png: 'PNG تصاویر',
    jpeg: 'JPEG تصاویر',
    webp: 'WebP تصاویر',
    gif: 'GIF تصاویر',
    pdf: 'PDF دستاویزات',
    typesRequired: 'کم از کم ایک قسم کی فائل چنیں۔',
    maxMegabytes: 'سب سے بڑی فائل (MB)',
    maxMegabytesHint: '1 سے 10 تک۔',
    maxFiles: 'ایک پیغام میں فائلیں',
    maxFilesHint: '1 سے 5 تک۔',
  },
  help: {
    legend: 'گفتگو سے پہلے مدد',
    search: 'گاہک آپ کے عوامی مدد کے مضامین تلاش کر سکتے ہیں',
    suggestions: 'تجویز کردہ سوالات',
    suggestionsHint:
      '6 تک، چیٹ کی پہلی اسکرین پر۔ انگریزی ضروری ہے؛ خالی زبان میں انگریزی دکھتی ہے۔',
    question: 'سوال {{number}}',
    add: 'سوال شامل کریں',
    remove: 'سوال {{number}} ہٹائیں',
    required: 'سوال {{number}} انگریزی میں لکھیں۔',
  },
  deletion: {
    label: 'گاہک اتنی دیر تک پیغام حذف کر سکتے ہیں (منٹ)',
    hint: '0 سے 60 تک۔ 0 سے حذف کرنا بند ہو جاتا ہے۔',
  },
  emails: {
    label: 'سائن ان گاہکوں کو ان کی گفتگو کے بارے میں ای میلز کی پیشکش کریں',
    hint: 'گفتگو بند ہونے پر ایک نقل، اور جواب کے انتظار میں ہونے پر اطلاع۔ گاہک خود چنتے ہیں، اور ہر ای میل میں انہیں روکنے کا لنک ہوتا ہے۔',
  },
};
